/* eslint-disable @typescript-eslint/no-unused-vars,prefer-destructuring */

jQuery.fn.visibleInScroll = function (goDeep) {
  let parent = $(this[0]).scrollParent()[0];
  let elRect = this[0].getBoundingClientRect();
  const rects = [parent.getBoundingClientRect()];
  elRect = {
    left: elRect.left,
    top: elRect.top,
    right: elRect.right,
    bottom: elRect.bottom,
    width: elRect.width,
    height: elRect.height,
    visibleWidth: elRect.width,
    visibleHeight: elRect.height,
    isVisible: true,
    isContained: true,
  };
  const elWidth = elRect.width;
  const elHeight = elRect.height;
  if (parent === this[0].ownerDocument) {
    return elRect;
  }

  while (parent !== this[0].ownerDocument && parent !== null) {
    if (parent.scrollWidth > parent.clientWidth || parent.scrollHeight > parent.clientHeight) {
      rects.push(parent.getBoundingClientRect());
    }
    if (rects.length && goDeep) {
      break;
    }
    parent = $(parent).scrollParent()[0];
  }
  if (!goDeep) {
    rects.length = 1;
  }
  for (let i = 0; i < rects.length; i += 1) {
    const rect = rects[i];
    elRect.left = Math.max(elRect.left, rect.left);
    elRect.top = Math.max(elRect.top, rect.top);
    elRect.right = Math.min(elRect.right, rect.right);
    elRect.bottom = Math.min(elRect.bottom, rect.bottom);
  }
  elRect.visibleWidth = Math.max(0, elRect.right - elRect.left);
  elRect.visibleHeight = elRect.visibleWidth && Math.max(0, elRect.bottom - elRect.top);
  if (!elRect.visibleHeight) {
    elRect.visibleWidth = 0;
  }
  elRect.isVisible = elRect.visibleWidth > 0 && elRect.visibleHeight > 0;
  elRect.isContained = elRect.visibleWidth === elRect.width && elRect.visibleHeight === elRect.height;
  return elRect;
};
